<template>
  <div class="padding-x">
    <div class="mb-6">
      <div class="mt-2 mr-4" style="display: inline">
        <svg
          width="32"
          height="30"
          viewBox="0 0 32 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M32 27.0511C32 27.7987 31.7364 28.3689 31.2093 28.7618C30.6822 29.1548 30.0353 29.3512 29.2686 29.3512H2.73136C1.96466 29.3512 1.31776 29.15 0.790656 28.7474C0.263552 28.3449 0 27.7795 0 27.0511C0 26.4761 0.172507 25.8915 0.51752 25.2973L13.7718 2.18141C14.4043 1.1272 15.1518 0.600098 16.0144 0.600098C16.8769 0.600098 17.6053 1.1272 18.1995 2.18141L31.4825 25.3261C31.8275 25.9394 32 26.5144 32 27.0511ZM17.9982 12.3593V8.16164H14.0018V12.3593C14.0018 12.6277 14.021 12.8816 14.0593 13.1212C14.0976 13.3608 14.1503 13.6291 14.2174 13.9262C14.2845 14.2233 14.3372 14.4773 14.3756 14.6881L15.1231 19.3458H16.8194L17.5957 14.6881C17.634 14.4965 17.6915 14.2473 17.7682 13.9406C17.8449 13.6339 17.9024 13.3608 17.9407 13.1212C17.979 12.8816 17.9982 12.6277 17.9982 12.3593ZM17.9982 23.486C17.9982 22.9301 17.8017 22.4605 17.4088 22.0772C17.0159 21.6938 16.5415 21.5022 15.9856 21.5022C15.4489 21.5022 14.9841 21.6938 14.5912 22.0772C14.1983 22.4605 14.0018 22.9301 14.0018 23.486C14.0018 24.0418 14.1983 24.5162 14.5912 24.9092C14.9841 25.3021 15.4489 25.4986 15.9856 25.4986C16.5415 25.4986 17.0159 25.3021 17.4088 24.9092C17.8017 24.5162 17.9982 24.0418 17.9982 23.486Z"
            fill="#ED1C24"
          />
        </svg>
      </div>
      <p style="display: inline" v-if="canDownload">
        Only attendees with email opt-in can be used for marketing purposes via
        email
      </p>
      <p style="display: inline" v-else>
        Attendees list download will be available after the event.
      </p>
    </div>
    <vue-excel-xlsx
      :data="data"
      :columns="columns"
      :filename="eventName"
      :sheetname="fileEventName"
      v-if="canDownload"
    >
      Download
    </vue-excel-xlsx>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "Participants",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    eventName: {
      type: String,
      default: "",
    },
    date: {
      type: String,
      default: "",
    },
  },
  computed: {
    fileEventName() {
      const eventName = this.eventName;
      const fileName = `attendees_${this.eventName}`;

      if (fileName > 31 && eventName.length < 31) {
        return eventName;
      } else if (fileName.length < 31) {
        return fileName;
      }

      return `${eventName.substr(0, 28)}...`;
    },
    canDownload() {
      return moment(this.date).diff(moment()) < 0;
    },
  },
  data: () => ({
    columns: [
      {
        label: "Name",
        field: "first_name",
      },
      {
        label: "Last Name",
        field: "last_name",
      },
      {
        label: "Organization",
        field: "organization",
      },
      {
        label: "Job Title",
        field: "job_title",
      },
      {
        label: "Email",
        field: "email",
      },
      {
        label: "Phone",
        field: "phone",
      },
      {
        label: "Email opt-in",
        field: "optin",
      },
      {
        label: "Attended",
        field: "attended",
      },
      {
        label: "Connected From",
        field: "geo_ip_data",
      },
    ],
  }),
  methods: {},
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables";

button {
  display: block;
  padding: 12px 32px;
  border-radius: 10px;
  background-color: $red;
  color: $white;
  font-family: $Oswald;
  font-size: 1.3rem;
  line-height: 1;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  height: 56px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s, opacity 0.3s;

  &:hover {
    background-color: transparent;
    color: $red;
  }

  &:active {
    opacity: 0.6;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;

    &:hover {
      background-color: initial;
      color: initial;
    }
  }

  &-full-width {
    width: 100%;
  }

  &-outlined {
    background-color: transparent;
    color: $red;
    border: 2px solid $red;
  }

  &-outlined:hover {
    background-color: $red;
    color: $white;
  }

  @media (min-width: $media-sm) {
    height: 60px;
  }
}

.container {
  display: none;

  table {
    font-size: 14px;
    table-layout: fixed;
    width: 100%;
  }

  th,
  td {
    word-wrap: break-word;
    border: 1px solid black;
    max-width: 110px;
    padding: 6px;
  }

  @media (min-width: $media-md) {
    display: block;
  }
}
</style>
